import React from 'react';
import { ExportTranscriptModalContextType } from './types';

const ExportTranscriptModalContext = React.createContext<
  ExportTranscriptModalContextType | undefined
>(undefined);

export default ExportTranscriptModalContext;
